import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React, { useRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import HeroScene from './HeroScene'
import useIsOffscreen from './HeroScene/useIsOffscreen'

const t = buildTranslate('promo_codes.overview.hero')

const HeroAnimation = () => {
  const [css] = useStyletron()
  const containerRef = useRef<HTMLDivElement>(null)
  const isOffscreen = useIsOffscreen(containerRef)
  const prefersReducedMotion = useMediaQuery({
    query: '(prefers-reduced-motion: reduce)',
  })

  return (
    <div
      ref={containerRef}
      data-testid="promo-codes-hero-visual"
      className={css({
        backgroundColor: palette.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      })}
    >
      <HeroScene
        ariaLabel={t('animation_alt')}
        isStatic={prefersReducedMotion}
        isPaused={isOffscreen}
      />
    </div>
  )
}

export default HeroAnimation
